import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useSnackbar } from '@/features/snackbar';

import { mutationFn } from './mutationFn';
import { useNarrative } from '../useNarrative';
import type { ResolvedQueryData } from '@/utilities/genericTypes';

export const useDeleteNarrativeAnnouncement = (slug: string) => {
  const queryClient = useQueryClient();
  const { addSnackbar } = useSnackbar();

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.setQueryData<ResolvedQueryData<typeof useNarrative>>(
        useNarrative.getOptions({ slug }).queryKey,
        (state) => {
          if (typeof state === 'undefined') return state;
          const announcements = state.Narrative.announcements || [];
          return {
            Narrative: {
              ...state.Narrative,
              announcements: announcements.slice(0, -1),
            },
          };
        }
      );
      addSnackbar({
        type: 'positive',
        lifeTime: 1000,
        message: 'Narrative announcement successfully deleted',
      });
    },
    onError: () => {
      addSnackbar({
        type: 'negative',
        lifeTime: 2000,
        message: 'Failed to delete narrative annoucement',
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries(useNarrative.getOptions({ slug }));
    },
  });
};
